<template>
  <el-tooltip :content="value | moment(tooltipFormat)" :placement="tooltipPlacement">
    <span>{{ value | moment(format) }}</span>
  </el-tooltip>
</template>

<script>
  import {Tooltip} from 'element-ui'

  export default {
    name: 'HumanizedDate',
    components: {
      [Tooltip.name]: Tooltip
    },
    props: {
      value: ![Date, String],
      format: {
        type: String,
        default: () => 'from'
      },
      tooltipFormat: {
        type: String,
        default: () => 'DD.MM.YYYY hh:mm:ss'
      },
      tooltipPlacement: {
        type: String,
        default: () => 'top'
      }
    }
  }
</script>
